import request from '@/utils/request'

const API_PREFIX = '/wechat/login';
const API_PREFIX_WECHAT = '/wechat';

//登录微信二维码
export function loginQrcode(query) {
    return request({
        url:`${API_PREFIX}/qrcode`,
        method: 'get',
        query: query
    })
}


//登录查看二维码
export function loginCheck(query) {
    return request({
        url:`${API_PREFIX}/check?ticket=` + query,
        method: 'get',
    })
}

//登录后成功
export function loginRegister(data) {
    return request({
        url:`/uni/wechat/register`,
        method: 'post',
        data
    })
}


//前端通过 state 换取 token 和用户数据
export function getWechatLoginData(query) {
    return request({
        url:`${API_PREFIX}/getLoginData?state=` + query,
        method: 'get',
    })
}

// 登出
export function getMemberLogout() {
    return request({
        url:  `/wechat/logout`,
        method: 'get',
    })
}

// 查询手机号是登录还是注册
export function checkCaptcha(data) {
    return request({
        url:`${API_PREFIX_WECHAT}/check`,
        method: 'post',
        data
    })
}

// 查询微信openid
export function searchWeChatOpenid(ticket) {
    return request({
        url:`${API_PREFIX_WECHAT}/bind/qrcode?ticket=` + ticket,
        method: 'get'
    })
}


// 获取手机号验证码
export function getVerificationCode(phones) {
    return request({
        url:`/no-auth/sms/sendAliyun/` + phones,
        method: 'get'
    })
}

